// Module
var code = ` <template> <div class="page-rfq-processing"> <div class="banner"> <div class="row justify-content-center align-items-middle"> <comp-icon class="banner-icon" icon="tick-circled"></comp-icon> <h1 class="banner-title">Thank you for your request</h1> </div> <p class="banner-text">\${subTitleText}</p> </div> </div> </template>`;
// Exports
module.exports = code;